export const INVOICES_LIST = "PLATFORMS_PORTAL_INVOICES_LIST";